import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

import chartDonut from '@/components/charts/chartDonut/index.vue';
import pagination from '@/components/pagination/index.vue';
import preloader from '@/components/preloader/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

export default {
  mixins: [
    helpers.random_color,
    helpers.work_with_date,
  ],
  props: {
    lang: {
      type: Object,
      required: true,
    },
    managerList: {
      type: Array,
      default () {
        return [];
      },
    },
  },
  components: {
    Multiselect,
    DatePicker,
    chartDonut,
    pagination,
    preloader,
    empty,
  },
  data () {
    return {
      errorsData: [],
      responseData: [],
      chartDonutData: {},

      params: {
        source_language: '',
        target_language: '',
        type: 'projects',
        created_on: '',
        manager: '',
        page: 1,
        ppage: 8,
      },

      rerenderKey: 0,

      date: '',
      load: true,
    };
  },
  watch: {
    'params.created_on' () {
      this.getAverageErrors();
    },
  },
  created () {
    this.getAverageErrors();
  },
  methods: {

    /**
         * Method return string for multiselect
         *
         * @param {Number} count
         */
    limitText (count) {
      return `and ${count} others manager`;
    },

    getAverageErrors () {
      this.refreshData();

      Api.dashboard.main
        .getAverage(this.transformParams())
        .then((data) => {
          if (data.data.Status) {
            this.errorsData = data.data.Data;
            this.responseData = data.data;

            if (this.errorsData.length != 0) {
              this.errorsData.forEach((item, index) => {
                item.ErrorPointsAverage = item.StatData.reduce((total, current) => total + current.ErrorPointsAverage, 0);
                item.MajorCount = item.StatData.reduce((total, current) => total + current.MajorCount, 0);
                item.MinorCount = item.StatData.reduce((total, current) => total + current.MinorCount, 0);
              });

              this.errorsData.forEach((el, index) => {
                index === 0 ? el.Checked = true : el.Checked = false;
              });

              this.drawChart();
            }
          } else {
            this.errorsData = [];
          }

          this.load = false;
        });
    },

    refreshData () {
      this.load = true;
      this.chartDonutData = {};
    },

    changeTab (type) {
      this.params = {
        source_language: '',
        target_language: '',
        created_on: '',
        type: type,
        manager: '',
        page: 1,
        ppage: 8,
      };

      this.getAverageErrors();
    },

    /**
         * Method select type
         *
         * @param {String} type
         * @param {Object} event
         */
    selectItem (type, event) {
      this.params[type] = event;
      this.getAverageErrors();
    },

    /**
         * Method for remove select item
         *
         * @param {String} type
         */
    removeItem (type) {
      this.params[type] = '';
      this.getAverageErrors();
    },

    drawChart () {
      this.$set(this.chartDonutData, 'inside', []);
      this.$set(this.chartDonutData, 'outside', []);

      this.errorsData.forEach((el) => {
        if (el.Checked) {
          if (el.StatData !== null) {
            el.StatData.forEach((item) => {
              const arOutside = {
                name: item.Name,
                y: item.ErrorPointsAverage,
                color: this.generateColor(),
              };

              this.chartDonutData.outside.push(arOutside);
            });
          }
        }
      });

      this.rerenderKey = this.rerenderKey + 1;
    },

    changeCheck (id) {
      this.errorsData.forEach((el) => {
        el.ID === id ? el.Checked = true : el.Checked = false;
      });
      this.drawChart();
    },

    sendPage (page) {
      this.params.page = page;
      this.getAverageErrors();
    },

    transformParams () {
      const params = {
        source_language: this.params.source_language != '' ? this.params.source_language.ID : '',
        target_language: this.params.target_language != '' ? this.params.target_language.ID : '',
        type: this.params.type,
        manager: this.params.manager ? this.params.manager.ID : '',
        page: this.params.page,
        ppage: this.params.ppage,
        created_on: this.convertDatePickerInUnix(this.params.created_on),
      };

      return params;
    },
  },
};
